import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ReleaseOfUnwantedCnaeService } from '../../services/release-of-unwanted-cnae.service';
import { MatDialog } from '@angular/material/dialog';
import { Messages } from 'src/app/shared/messages/messages';
import { DialogService } from 'src/app/shared/service/dialog.service';
import { ErrorService } from 'src/app/shared/service/error.service';
import { LoadingService } from 'src/app/shared/service/loading.service';
import { ReleaseOfUnwantedCnaeModel, ReleaseOfUnwantedCnaeUpdateStatusModel } from '../../models/releaseOfUnwantedCnae.models';
import { finalize } from 'rxjs/operators';
import { AuditReleaseOfUnwantedCnaeComponent } from '../audit-release-of-unwanted-cnae/audit-release-of-unwanted-cnae.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-list-release-of-unwanted-cnae',
  standalone: false,
  templateUrl: './list-release-of-unwanted-cnae.component.html',
  styleUrl: './list-release-of-unwanted-cnae.component.scss'
})
export class ListReleaseOfUnwantedCnaeComponent implements OnChanges {

  constructor(
    readonly releaseOfUnwantedCnaeService: ReleaseOfUnwantedCnaeService,
    readonly dialogService: DialogService,
    readonly errorService: ErrorService,
    readonly loadingService: LoadingService,
    readonly dialog: MatDialog,
  ) { }

  displayedColumns = ['id', 'cnpj', 'name', 'cnae', 'releasePeriod', 'options_edit'];
  defaultSizeItems = 10;

  hasValue = false;

  @Input() dataSource: MatTableDataSource<ReleaseOfUnwantedCnaeModel> = new MatTableDataSource<ReleaseOfUnwantedCnaeModel>();
  @Input() totalItens: number = 0;
  @Input() page: number = 0;

  @Output() changePage = new EventEmitter<PageEvent>();
  @Output() searchEvent: EventEmitter<void> = new EventEmitter();
  @Output() editEvent: EventEmitter<ReleaseOfUnwantedCnaeModel> = new EventEmitter<ReleaseOfUnwantedCnaeModel>();
  @Output() updateStatusEvent: EventEmitter<ReleaseOfUnwantedCnaeUpdateStatusModel> = new EventEmitter<ReleaseOfUnwantedCnaeUpdateStatusModel>();

  ngOnChanges() {
     if (!this.dataSource) {
      return;
    }
    if (this.dataSource.data.length > 0) {
      this.hasValue = true;
    } else {
      this.hasValue = false;
    }
  }

  change(event: PageEvent): void {
    this.changePage.emit(event);
  }

  enable(id: number) {
    this.dialogService.openConfirmDialog(Messages.CONFIRM_ENABLE_RELEASE_OF_UNWANTED_CNAE,
    () => {
      this.updateStatusEvent.emit({ id: id, isEnabled: true });
    });
  }

  disable(id: number) {
    this.dialogService.openConfirmDialog(Messages.CONFIRM_DISABLE_RELEASE_OF_UNWANTED_CNAE,
    () => {
      this.updateStatusEvent.emit({ id: id, isEnabled: false });
    });
  }

  showAudit(id: number) {
    this.loadingService.show();
    this.releaseOfUnwantedCnaeService.getAudit(id).pipe(
      finalize(() => this.loadingService.hide())
    ).subscribe(auditData => {
      this.dialog.open(AuditReleaseOfUnwantedCnaeComponent, {
        width: '80%',
        height: '60%',
        autoFocus: false,
        data: auditData
      });
    }, (err: HttpErrorResponse) => {
      this.errorService.handleXHRError(err, Messages.SEARCH_ERROR);
    }
    );
  }

  edit(item: ReleaseOfUnwantedCnaeModel) {
    this.editEvent.emit(item);
  }
}
